if (!readCookie("joinTheMovementToast")) {
    setTimeout(() => {
        $('.subscribe-toast').toast('show');
    }, 4000);
    createCookie("joinTheMovementToast", "1", 100);
} else {}

function createCookie(name, value, days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
    } else var expires = "";
    document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

var devicesWithPointer = false;
mediaTouchDevices();

// Site Navigation Overflow Stopped on Navbar Toggle
$('#siteNavigation').on('show.bs.collapse', function () {
    $('body').addClass('overflow-stopped');
}).on('hide.bs.collapse', function () {
    $('body').removeClass('overflow-stopped');
});

getHeaderHeight();
hasAnnouncement();
$('a[smooth-scroll]').on('click', function (event) {
    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 140
    }, 500);
    event.preventDefault();
});

$('.notification-toggler').on('click', function (e) {
    e.preventDefault();
    $('.site-header__notification').slideUp(function () {
        getHeaderHeight();
        hasAnnouncement();
    });
});

$('.cart-sidebar__toggler').on('click', function (e) {
    e.preventDefault();
    $('.cart-sidebar').toggleClass('show');
    $('.cart-sidebar__overlay').fadeToggle();
});

$('.cart-sidebar__overlay').on('click', function (e) {
    e.preventDefault();
    $('.cart-sidebar').toggleClass('show');
    $(this).fadeToggle();
});

$(window).on(
    'load',
    function () {
        $('.flickity-enabled').flickity('resize');
        ScrollTrigger.refresh();
        getHeaderHeight();
        hasAnnouncement();
    }
);

$(window).on(
    'resize',
    function () {
        ScrollTrigger.refresh();
        getHeaderHeight();
        hasAnnouncement();
    }
);

// Product Quantity
$('.btn-number').on('click', function (e) {
    e.preventDefault();
    var qty_btn = $(this);
    updateInput(qty_btn);
});

function updateInput(qty_btn) {
    fieldName = qty_btn.attr('data-field');
    type = qty_btn.attr('data-type');
    var input = qty_btn.siblings("input[name='" + fieldName + "']");
    var currentVal = parseInt(input.val());
    // console.log(currentVal);
    if (!isNaN(currentVal)) {
        if (type == 'minus') {
            if (currentVal > input.attr('min')) {
                input.val(currentVal - 1).change();
            }
            if (parseInt(input.val()) == input.attr('min')) {
                qty_btn.attr('disabled', true);
            }
        } else if (type == 'plus') {
            if (currentVal < input.attr('max')) {
                input.val(currentVal + 1).change();
            }
            if (parseInt(input.val()) == input.attr('max')) {
                qty_btn.attr('disabled', true);
            }
        }
    } else {
        input.val(0);
    }
}
$('.input-number').on('focusin', function () {
    $(this).data('oldValue', $(this).val());
});
$('.input-number').on('change', function () {
    minValue = parseInt($(this).attr('min'));
    maxValue = parseInt($(this).attr('max'));
    valueCurrent = parseInt($(this).val());
    name = $(this).attr('name');
    if (valueCurrent >= minValue) {
        $(".btn-number[data-type='minus'][data-field='" + name + "']").removeAttr(
            'disabled')
    } else {
        alert('Sorry, the minimum value was reached');
        $(this).val($(this).data('oldValue'));
    }
    if (valueCurrent <= maxValue) {
        $(".btn-number[data-type='plus'][data-field='" + name + "']").removeAttr('disabled')
    } else {
        alert('Sorry, the maximum value was reached');
        $(this).val($(this).data('oldValue'));
    }
});
$(".input-number").on('keydown', function (e) {
    // Allow: backspace, delete, tab, escape, enter and .
    if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode == 65 && e.ctrlKey === true) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
        // let it happen, don't do anything
        return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode >
            105)) {
        e.preventDefault();
    }
});

var $featuredInCarousel = $('.as-featured-in__carousel');
$featuredInCarousel.flickity({
    cellAlign: 'left',
    wrapAround: true,
    imagesLoaded: true,
    autoPlay: 3000,
    pauseAutoPlayOnHover: true,
    pageDots: false,
    prevNextButtons: false,
});
var $testimonialsCarousel = $('.testimonials__carousel');
$testimonialsCarousel.flickity({
    wrapAround: true,
    imagesLoaded: true,
    autoPlay: 5000,
    pauseAutoPlayOnHover: true,
    prevNextButtons: false,
    adaptiveHeight: true,
    setGallerySize: false,
});

$testimonialsCarousel.on('settle.flickity', function (event, index) {
    $testimonialsCarousel.flickity('playPlayer');
});

// select-picker
$('.select-wrapper').each(function () {
    var btnClass = $(this).data('button-style');
    $(this).find('.select-picker').selectpicker({
        style: '',
        styleBase: btnClass,
        width: false
    });
});

var $pdpCarousel = $('.product-detail__showcase');
$pdpCarousel.flickity({
    wrapAround: true,
    imagesLoaded: true,
    prevNextButtons: false,
    watchCSS: true,
    cellSelector: '.carousel-cell',
    pageDots: false,
});

var $productsCarousel = $(document).find('.sliderInit');
$productsCarousel.flickity({
    wrapAround: true,
    imagesLoaded: true,
    prevNextButtons: false,
    pageDots: false,
    cellAlign: 'left',
});

var $carouselMobile = $(document).find('.sliderInitMobile');
$carouselMobile.flickity({
    wrapAround: true,
    imagesLoaded: true,
    prevNextButtons: false,
    pageDots: false,
    cellAlign: 'left',
});

$('.collections .accordion-filter').on('click', function (e) {
    $('.collections .sidebar').slideToggle();
});

gsap.registerPlugin(ScrollTrigger);

let contentWithImageWrapper = $('.content-with-image--hover .content-with-image__thumbnail');
let contentWithImageEl = $('.content-with-image--hover .content-with-image__thumbnail .image-hover');

let contentWithImageAnim = gsap.timeline({
    scrollTrigger: {
        trigger: contentWithImageWrapper,
        start: 'top top+=200',
        end: "top",
        pin: false,
        toggleActions: "play none none reverse",
    },
});

contentWithImageAnim.fromTo(contentWithImageEl, {
    opacity: 0,
    ease: 'power'
}, {
    opacity: 1,
});

let contentWithImageAltWrapper = $('.content-with-image--alt .content-with-image__thumbnail');

let contentWithImageAltEl__top = $('.content-with-image--alt .content-with-image__thumbnail .content-with-image__thumbnail__top');

let contentWithImageAltEl__bottom = $('.content-with-image--alt .content-with-image__thumbnail .content-with-image__thumbnail__bottom');

let contentWithImageAltEl__caption__non_hover = $('.content-with-image--alt .content-with-image__thumbnail .content-title--non-hover');

let contentWithImageAltEl__caption__hover = $('.content-with-image--alt .content-with-image__thumbnail .content-title--hover');

let contentWithImageAltAnim = gsap.timeline({
    scrollTrigger: {
        trigger: contentWithImageAltWrapper,
        start: 'top top+=200',
        end: "center",
        pin: false,
        toggleActions: "play none none reverse",
    },
}); 

contentWithImageAltAnim.to(contentWithImageAltEl__top, {
    opacity: 0,
    ease: 'none'
}).to(contentWithImageAltEl__bottom, {
    opacity: 0,
    ease: 'none'
}, 0).to(contentWithImageAltEl__caption__non_hover, {
    opacity: 0,
    ease: 'none'
}, 0).to(contentWithImageAltEl__caption__hover, {
    opacity: 1,
    ease: 'none'
}, 0);


function getHeaderHeight() {
    var headerHeight = document.querySelector('.site-header').offsetHeight + document.getElementById('shopify-section-announcement-bar').offsetHeight;
    document.documentElement.style
        .setProperty('--header-height', headerHeight + 'px');
}

var __announcementHeight = $('#shopify-section-announcement-bar').outerHeight();
var __headerHeight = $('#shopify-section-header').outerHeight();

function hasAnnouncement() {
    if ($(window).scrollTop() > __announcementHeight) {
        document.documentElement.style
            .setProperty('--announcement-height', __headerHeight + 'px');
        return;
    } else {
        let __scrollPosition = parseInt($(window).scrollTop());
        let __offset = $('#shopify-section-header').offset();
        let __offsetHeader = parseInt((__offset.top + __headerHeight) - __scrollPosition);
        document.documentElement.style
            .setProperty('--announcement-height', __offsetHeader + 'px');
    }
}


$(window).on(
    'scroll',
    function () {
        hasAnnouncement();
        if ($(window).scrollTop() > __announcementHeight ) {
            $('#shopify-section-header').addClass('sticked_header');
        } else {
            $('#shopify-section-header').removeClass('sticked_header');
        }
    });

$('.site-header .site-header__navbar .dropdown').on('mouseenter', function () {
    if (devicesWithPointer)
        $(this).find('[data-toggle="dropdown"]').dropdown('show');
}).on('mouseleave', function () {
    if (devicesWithPointer)
        $(this).find('[data-toggle="dropdown"]').dropdown('hide').attr('aria-expanded', false);;
});

$(window).on('resize', function () {
    mediaTouchDevices();
});

function mediaTouchDevices() {
    if (window.matchMedia('(any-hover: none)').matches) {
        devicesWithPointer = false;
    } else {
        devicesWithPointer = true;
    }
}
$('#custom-filter input[type=radio]').on('change', function (e) {
    $('#custom-filter--submit').trigger('click');
});

alignedToContainer();

function alignedToContainer(params) {
    let boxes = $('.cb-spacer-box');
    if (boxes.length) {
        $.each(boxes, function (indexInArray, valueOfElement) {
            if ($(this).closest('.container').length) {
                return;
            } else {
                let $container = $('.site-footer .container');
                let $parent = $(this).closest('.cb-spacer-box-padding');
                let __containerMarginLeft = parseInt($($container).css('margin-left'));
                let __parentPaddingLeft = parseInt($($parent).css('padding-left'));
                let __marginLeft = __containerMarginLeft - __parentPaddingLeft + 15;
                $(this).css('margin-left', __marginLeft);
            }
        });
    }
}

// Animation
AOS.init();

$(window).on(
    'load',
    function () {
        setTimeout(() => {
            AOS.refresh();
        }, 200);
    }
);

$(window).on(
    'resize',
    function () {
        alignedToContainer();
        AOS.refresh();
    }
);
